import React from "react";
import {
  MDBBadge,
  MDBBtn,
  MDBCol,
  MDBContainer,
  MDBInput,
  MDBRow,
  MDBSpinner,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import { Form } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

export class AuditoriaAccesos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      total: 0,
      page: 1,
      pageSize: 50,
      loading: false,
      filterApodo: "",
      filterResultado: "",
      filterApp: "",
      filterDesde: "",
      filterHasta: "",
    };
  }

  componentDidMount() {
    this.loadAudit();
  }

  formatDateTimeForQuery(val) {
    if (!val) return "";
    let v = val.replace("T", " ");
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(v)) v += ":00";
    return v;
  }

  buildQueryString() {
    const { page, pageSize, filterApodo, filterResultado, filterApp, filterDesde, filterHasta } =
      this.state;
    let params = `page=${page}&pageSize=${pageSize}`;
    if (filterApodo) params += `&apodo=${encodeURIComponent(filterApodo)}`;
    if (filterResultado) params += `&resultado=${encodeURIComponent(filterResultado)}`;
    if (filterApp) params += `&appCode=${encodeURIComponent(filterApp)}`;
    if (filterDesde)
      params += `&desde=${encodeURIComponent(this.formatDateTimeForQuery(filterDesde))}`;
    if (filterHasta)
      params += `&hasta=${encodeURIComponent(this.formatDateTimeForQuery(filterHasta))}`;
    return params;
  }

  loadAudit() {
    this.setState({ loading: true });
    if (this.props.onLoading) this.props.onLoading(true);

    const method = `getLoginAudit?${this.buildQueryString()}`;

    doFetch("SSO", method, { method: "GET" })
      .then((r) => r.json())
      .then((data) => {
        this.setState({
          data: data.DATA || [],
          total: data.TOTAL || 0,
        });
      })
      .catch((err) => {
        console.error("Error AuditoriaAccesos:", err);
        this.setState({ data: [], total: 0 });
      })
      .finally(() => {
        this.setState({ loading: false });
        if (this.props.onLoading) this.props.onLoading(false);
      });
  }

  applyFilters() {
    this.setState({ page: 1 }, () => this.loadAudit());
  }

  clearFilters() {
    this.setState(
      {
        page: 1,
        filterApodo: "",
        filterResultado: "",
        filterApp: "",
        filterDesde: "",
        filterHasta: "",
      },
      () => this.loadAudit()
    );
  }

  getResultadoBadgeColor(resultado) {
    switch (resultado) {
      case "SUCCESS":
        return "success";
      case "FAIL_CREDENTIALS":
        return "danger";
      case "FAIL_USER_NOT_FOUND":
        return "warning";
      case "FAIL_INACTIVE":
        return "secondary";
      case "FAIL_LOCKED":
        return "warning";
      case "EXCEPTION":
        return "dark";
      default:
        return "secondary";
    }
  }

  getResultadoLabel(resultado) {
    switch (resultado) {
      case "SUCCESS":
        return "Éxito";
      case "FAIL_CREDENTIALS":
        return "Contraseña incorrecta";
      case "FAIL_USER_NOT_FOUND":
        return "Usuario no encontrado";
      case "FAIL_INACTIVE":
        return "Usuario inactivo";
      case "FAIL_LOCKED":
        return "Bloqueado";
      case "EXCEPTION":
        return "Error interno";
      default:
        return resultado || "-";
    }
  }

  formatDateTime(val) {
    if (!val) return "-";
    const d = new Date(val);
    if (isNaN(d.getTime())) return String(val);
    return d.toLocaleString("es-ES", { hour12: false });
  }

  render() {
    const {
      data,
      total,
      page,
      pageSize,
      loading,
      filterApodo,
      filterResultado,
      filterApp,
      filterDesde,
      filterHasta,
    } = this.state;

    const totalPages = Math.ceil(total / pageSize);

    return (
      <MDBContainer fluid className="mt-3">
        <h5 className="mb-3">Auditoría de accesos</h5>

        {/* Filter row */}
        <MDBRow className="g-2 mb-3 align-items-end">
          <MDBCol md="2">
            <MDBInput
              type="text"
              size="sm"
              label="Usuario"
              value={filterApodo}
              onChange={(e) => this.setState({ filterApodo: e.target.value })}
            />
          </MDBCol>
          <MDBCol md="2">
            <Form.Select
              size="sm"
              value={filterResultado}
              onChange={(e) => this.setState({ filterResultado: e.target.value })}
            >
              <option value="">Todos los resultados</option>
              <option value="SUCCESS">Éxito</option>
              <option value="FAIL_CREDENTIALS">Contraseña incorrecta</option>
              <option value="FAIL_USER_NOT_FOUND">Usuario no encontrado</option>
              <option value="FAIL_INACTIVE">Usuario inactivo</option>
              <option value="FAIL_LOCKED">Bloqueado</option>
              <option value="EXCEPTION">Error interno</option>
            </Form.Select>
          </MDBCol>
          <MDBCol md="1">
            <MDBInput
              type="text"
              size="sm"
              label="App"
              value={filterApp}
              onChange={(e) => this.setState({ filterApp: e.target.value })}
            />
          </MDBCol>
          <MDBCol md="2">
            <MDBInput
              type="datetime-local"
              size="sm"
              label="Desde"
              value={filterDesde}
              onChange={(e) => this.setState({ filterDesde: e.target.value })}
            />
          </MDBCol>
          <MDBCol md="2">
            <MDBInput
              type="datetime-local"
              size="sm"
              label="Hasta"
              value={filterHasta}
              onChange={(e) => this.setState({ filterHasta: e.target.value })}
            />
          </MDBCol>
          <MDBCol md="auto">
            <MDBBtn size="sm" onClick={() => this.applyFilters()}>
              Buscar
            </MDBBtn>
          </MDBCol>
          <MDBCol md="auto">
            <MDBBtn size="sm" color="secondary" onClick={() => this.clearFilters()}>
              Limpiar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        {loading ? (
          <div className="text-center py-4">
            <MDBSpinner />
          </div>
        ) : (
          <>
            <p className="text-muted mb-2">{total} registros encontrados</p>
            <MDBTable align="middle" striped hover responsive>
              <MDBTableHead>
                <tr>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>App</th>
                  <th>Resultado</th>
                  <th>IP</th>
                  <th>Dispositivo</th>
                  <th>Detalle</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center text-muted">
                      Sin registros
                    </td>
                  </tr>
                ) : (
                  data.map((row) => (
                    <tr key={row.idAudit}>
                      <td style={{ whiteSpace: "nowrap" }}>
                        <small>{this.formatDateTime(row.fechaIntento)}</small>
                      </td>
                      <td>
                        <span className="fw-bold">{row.apodo}</span>
                        {row.nombre && (
                          <>
                            <br />
                            <small className="text-muted">
                              {row.nombre} {row.apellido}
                            </small>
                          </>
                        )}
                      </td>
                      <td>
                        {row.appCode ? (
                          <MDBBadge color="info" pill>
                            {row.appCode}
                          </MDBBadge>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>
                        <MDBBadge color={this.getResultadoBadgeColor(row.resultado)} pill>
                          {this.getResultadoLabel(row.resultado)}
                        </MDBBadge>
                      </td>
                      <td>
                        <small>{row.ip || "-"}</small>
                      </td>
                      <td>
                        {row.userAgent ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{row.userAgent}</Tooltip>}
                          >
                            <small
                              className="text-truncate d-inline-block"
                              style={{ maxWidth: 160, cursor: "help" }}
                            >
                              {row.userAgent.length > 50
                                ? row.userAgent.substring(0, 50) + "…"
                                : row.userAgent}
                            </small>
                          </OverlayTrigger>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>
                        <small>{row.detalle || "-"}</small>
                      </td>
                    </tr>
                  ))
                )}
              </MDBTableBody>
            </MDBTable>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-between align-items-center mt-2">
                <MDBBtn
                  size="sm"
                  color="light"
                  disabled={page <= 1}
                  onClick={() => this.setState({ page: page - 1 }, () => this.loadAudit())}
                >
                  &laquo; Anterior
                </MDBBtn>
                <span className="text-muted">
                  Página {page} de {totalPages}
                </span>
                <MDBBtn
                  size="sm"
                  color="light"
                  disabled={page >= totalPages}
                  onClick={() => this.setState({ page: page + 1 }, () => this.loadAudit())}
                >
                  Siguiente &raquo;
                </MDBBtn>
              </div>
            )}
          </>
        )}
      </MDBContainer>
    );
  }
}
